import { render, staticRenderFns } from "./SectionCasesSelected.vue?vue&type=template&id=6d847134&"
import script from "./SectionCasesSelected.vue?vue&type=script&lang=js&"
export * from "./SectionCasesSelected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports